import React from "react";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  HeaderFilter,
  FilterRow,
} from "devextreme-react/data-grid";
import { Editing } from "devextreme-react/scheduler";
import { criarQualificacaoSociosDs } from "../DataSources";
import uiInfo from "../ui-info";

export default class QualificacaoSociosBox extends React.Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <strong>
          <h3>Qualificação Sócios</h3>
        </strong>
        <DataGrid
          dataSource={criarQualificacaoSociosDs()}
          showBorders={true}
          rowAlternationEnabled={true}
          remoteOperations={true}
          focusedRowEnabled={true}
          wordWrapEnabled={true}
        >
          <HeaderFilter visible={false} />
          <FilterRow visible={true} />
          <Editing
            mode={"row"}
            allowAdding={false}
            allowUpdating={true}
            allowDeleting={true}
          />
          <Column
            dataField={"id"}
            caption={"#"}
            alignment={"center"}
            width={"80"}
            allowEditing={false}
          />
          <Column dataField={"descricao"} caption={"Descrição"} />
          <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
          <Pager
            showPageSizeSelector={true}
            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
          />
        </DataGrid>
      </div>
    );
  }
}
